interface PauseMenuProps {
  onResume: () => void
  onRestart: () => void
}

export function PauseMenu({ onResume, onRestart }: PauseMenuProps) {
  return (
    <section className="modal-panel pause-menu" role="dialog" aria-modal="true" aria-labelledby="pause-title">
      <p className="eyebrow">SYSTEM HOLD</p>
      <h2 id="pause-title">RACE PAUSED</h2>
      <p>The grid is frozen. Your line is waiting.</p>
      <div className="modal-actions">
        <button className="primary-button" type="button" onClick={onResume}>
          Resume race
        </button>
        <button className="secondary-button" type="button" onClick={onRestart}>
          Restart race
        </button>
      </div>
    </section>
  )
}
